import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import http from "../services/httpService";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast, { Toaster } from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import { createEmailPath, getDate, getDateTime } from "../utils/varialbles";
import FilterListSharpIcon from "@material-ui/icons/FilterListSharp";
import { makeStyles } from "@material-ui/core/styles";
import ReactReadMoreReadLess from "react-read-more-read-less";

const columns = [
  { id: "empfname", label: "RM Name", minWidth: 100 },
  { id: "username", label: "Mobile Number", minWidth: 150, maxWidth: 200 },
  { id: "cust_name", label: "Customer Name", minWidth: 150, format: "name" },
  {
    id: "tasktype",
    label: "Task Type",
    minWidth: 150,
    maxWidth: 500,
    format: "taskname",
  },
  { id: "status", label: "Status", minWidth: 150 },
  { id: "date", label: "Task Date", minWidth: 150, format: "date" },
  { id: "commments", label: "Comments", minWidth: 150 },
  { id: "tasktype", label: "Action", minWidth: 150, format: "action" },
];

const useStyles = makeStyles({});
//   root: {
//     width: "100%",
//   },
//   table: {
//     field: "Resizing",
//     title: "Column Width",
//     cellStyle: {
//       whiteSpace: "nowrap",
//       width: "20%",
//     },
//   },
//   tableRow: {
//     "&:hover": {
//       cursor: "pointer",
//     },
//   },
//   indeterminateColor: {
//     color: "#f50057",
//   },
//   selectAllText: {
//     fontWeight: 500,
//   },
//   selectedAll: {
//     backgroundColor: "rgba(0, 0, 0, 0.08)",
//     "&:hover": {
//       backgroundColor: "rgba(0, 0, 0, 0.08)",
//     },
//   },
//   radio: {
//     "&$checked": {
//       color: "#57bf74",
//     },
//   },
//   checked: {},
// });

function InvAllTasklist() {
  const classes = useStyles();
  var [rows, setRows] = useState([]);
  // (rows);
  const location = useLocation();
  const myparam = location.state;
  let history = useHistory();
  const [showFilterExe, setShowFilterExex] = useState(false);

  const [namesList, setNamesList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [statusList, setStatusList] = useState([]);
  const [tasksList, setTasksList] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [filterStat, setFilterStat] = useState({
    names: "",
    status: "",
    tasks: "",
  });

  // (filterStat);

  var statFilterURL = "";

  const statCharObj = [
    { name: "Onboarding Pending", value: "P" },
    { name: "Onboarding Started", value: "S" },
    { name: "Onboarding Completed", value: "C" },
  ];

  const taskValuChange = (e) => {
    var statFillvalue = e.target.value;
    // (e.target.value);
    // (statFillvalue);
    // let finalStat = statCharObj.map(item=>
    //   {
    //     if(item.name === statFillvalue){
    //       statFillvalue = item.value;
    //     }
    //   })
    //   // (statFillvalue);
    setFilterStat({ ...filterStat, [e.target.name]: statFillvalue });
  };

  if (filterStat.names && filterStat.status && filterStat.tasks) {
    statFilterURL = `?page_type=I&name=${filterStat.names}&status=${filterStat.status}&task_status=${filterStat.tasks}`;
  } else if (filterStat.names && filterStat.status) {
    statFilterURL = `?page_type=I&name=${filterStat.names}&status=${filterStat.status}`;
  } else if (filterStat.names && filterStat.tasks) {
    statFilterURL = `?page_type=I&name=${filterStat.names}&task_status=${filterStat.tasks}`;
  } else if (filterStat.status && filterStat.tasks) {
    statFilterURL = `?page_type=I&status=${filterStat.status}&task_status=${filterStat.tasks}`;
  } else if (filterStat.names) {
    statFilterURL = `?page_type=I&name=${filterStat.names}`;
  } else if (filterStat.status) {
    statFilterURL = `?page_type=I&status=${filterStat.status}`;
  } else if (filterStat.tasks) {
    statFilterURL = `?page_type=I&task_status=${filterStat.tasks}`;
  } else {
    statFilterURL = "?page_type=I";
  }
  // (statFilterURL);

  const statFilterHandleClear = () => {
    statFilterURL = "?page_type=I";
    setFilterStat({
      names: "",
      status: "",
      tasks: "",
    });
    setShowFilterExex(false);
    getTaskList();
  };

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");
    getTaskList();
  }, [page, rowsPerPage]);

  const getTaskList = () => {
    toast.loading("Please wait...");

    http
      .get(
        `/gettasklist${statFilterURL}&page=${
          page + 1
        }&rowsPerPage=${rowsPerPage}`
      )
      .then((res) => {
        // (res.data.Data);
        const data = res.data.Data;
        toast.dismiss();
        const allNames = res.data.names;
        const allStatuses = res.data.status;
        const allTasks = res.data.task_status;

        setNamesList(allNames);
        setStatusList(allStatuses);
        setTasksList(allTasks);
        setTotalRowCount(res.data.totalRowCount);
        let finalStatus = data.map((item) => {
          // (item.status);
          if (item.status === "P") {
            item.status = "Onboarding Pending";
          } else if (item.status === "S") {
            item.status = "Onboarding Started";
          } else if (item.status === "C") {
            item.status = "Onboarding Completed";
          } else {
            item.status = "N/A";
          }
        });

        setRows(res.data.Data);
        // (setRows);
      })
      .catch((err) => {
        // (err);
      });
  };

  const [callBtnDisable, setCallBtnDisable] = useState(false);

  const callCustomer = (e, taskno, custId) => {
    e.preventDefault();

    if (custId) {
      setCallBtnDisable(true);
      http
        .get("/callrequest?cust_id=" + custId + "&location=I")
        .then((res) => {
          if (res && res.data && res.data.Data && res.data.statusCode === 0) {
            toast.success(
              "Call Request Placed successfully,Please wait for the call..!"
            );
            http
              .patch("/updatetaskstatus/" + taskno + "/")
              .then((res) => {
                // (res);
              })
              .catch((err) => {
                // (err);
              });
          } else {
            toast.error("Call Request Failed");
          }
        })
        .catch((err) => {
          toast.error("Call Request Failed");
        });
    }
  };

  const sendEmail = (e, taskno, comments, custId) => {
    if (custId) {
      history.push({
        pathname: createEmailPath,
        task: taskno,
        comments: comments,
        cust_id: custId,
        backString: "investtAllTask",
      });
    }
  };

  const [baseFile, setBaseFile] = useState({
    dataproof: "",
    cust: "",
  });

  const { cust, dataproof } = baseFile;

  const handleImageChange = async (e, taskno, custId) => {
    //alert("file received");
    const file = e.target.files[0];
    // (file);
    // (file.name);
    const base64 = await convertBase64(file);
    setBaseFile({ ...baseFile, dataproof: base64 });
    // sendfile(e, taskno, base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  var today = new Date();
  var dd = String(today.getDate());
  var mm = String(today.getMonth());
  var yyyy = today.getFullYear();
  let todaydate = yyyy + "-" + mm + "-" + dd;

  const sendfile = (e, taskno, custId, comment) => {
    const sendBase64 = {
      proof: dataproof,
      cust: custId,
      date: todaydate,
      communicationmode: "WhatsApp Call",
      duration: "0",
      time: "00:00",
      comments: comment,
    };
    http.post("/addcommunicationlog", sendBase64).then((res) => {
      // (res);
      if (res.data.Data && res.data.Data !== "Exception") {
        toast.success(res.data.Data);
        http
          .patch("/updatetaskstatus/" + taskno + "/")
          .then((res) => {
            // (res);
            // history(0);
            // window.location.reload(true);
          })
          .catch((err) => {
            // (err);
          });
      } else {
        toast.error("Task not created...");
      }
    });
  };

  // const [showTaskValue, setShowTaskValue] = useState('');
  // (showTaskValue);

  const showexefilter = () => {
    setShowFilterExex((val) => !val);
  };

  const cnacelSearch = () => {
    setShowFilterExex(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  return (
    <Paper>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "85px",
            columnGap: "5px",
          }}
        >
          <FilterListSharpIcon
            onClick={showexefilter}
            style={{ cursor: "pointer", marginLeft: 10 }}
          />

          {showFilterExe ? (
            <>
              <div>
                <label style={{ display: "inline-block", marginRight: "5px" }}>
                  Name
                </label>
                <select
                  onChange={taskValuChange}
                  name="names"
                  value={filterStat.names}
                  style={{
                    width: "150px",
                    height: "30px",
                    border: "1px solid #ddd",
                  }}
                >
                  <option value="">Select</option>
                  {namesList.map((item) => (
                    <option value={item.value}>{item.empfname}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: "inline-block", marginRight: "5px" }}>
                  Status
                </label>
                <select
                  onChange={taskValuChange}
                  name="status"
                  value={filterStat.status}
                  style={{
                    width: "150px",
                    height: "30px",
                    border: "1px solid #ddd",
                  }}
                >
                  <option value="">Select</option>
                  {statusList.map((item) => (
                    <option value={item.value}>{item.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: "inline-block", marginRight: "5px" }}>
                  Tasks
                </label>
                <select
                  onChange={taskValuChange}
                  name="tasks"
                  value={filterStat.tasks}
                  style={{
                    width: "150px",
                    height: "30px",
                    border: "1px solid #ddd",
                  }}
                >
                  <option value="">Select</option>
                  {tasksList.map((item) => (
                    <option value={item.value}>{item.empfname}</option>
                  ))}
                </select>
              </div>
              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ marginLeft: "20px", marginRight: "15px" }}
                  onClick={statFilterHandleClear}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={getTaskList}
                >
                  Apply
                </Button>
              </div>
            </>
          ) : null}
        </div>
        <div>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 1500]}
            component="div"
            count={totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    maxWidth: column.maxWidth,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length !== 0 ? (
              <>
                {rows.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index + "a"}
                    >
                      {columns.map((column, index) => {
                        const custId = row.cust_id;
                        const comment = row.commments;
                        const taskid = row.id;
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={index + column.id}
                            align={column.align}
                            style={{
                              minWidth: column.minWidth,
                              maxWidth: column.maxWidth,
                            }}
                          >
                            {column.format === "taskname" && value === 1 ? (
                              "Follow Up Call"
                            ) : column.format === "taskname" && value === 2 ? (
                              "Follow Up Mail"
                            ) : column.format === "taskname" && value === 3 ? (
                              "Follow Up Message"
                            ) : column.format === "taskname" && value === 4 ? (
                              "Call Back"
                            ) : column.format === "action" &&
                              (value === 1 || value === 4) ? (
                              <button
                                onClick={(e) => callCustomer(e, taskid, custId)}
                                className="buttontask"
                              >
                                Call
                              </button>
                            ) : column.format === "action" && value === 2 ? (
                              <button
                                onClick={(e) =>
                                  sendEmail(e, taskid, comment, custId)
                                }
                                className="buttontask"
                              >
                                Mail
                              </button>
                            ) : column.format === "action" && value === 3 ? (
                              <>
                                <label for="itag" style={{ cursor: "pointer" }}>
                                  Choose file
                                </label>
                                <input
                                  id="itag"
                                  type="file"
                                  style={{ width: 100, display: "none" }}
                                  onChange={(e) => {
                                    handleImageChange(
                                      e,
                                      taskid,
                                      custId,
                                      comment
                                    );
                                  }}
                                  name="proof"
                                  multiple={false}
                                  accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                                />
                                <button
                                  className="buttontask"
                                  onClick={(e) =>
                                    sendfile(e, taskid, custId, comment)
                                  }
                                >
                                  Save
                                </button>
                              </>
                            ) : column.format === "name" && value === null ? (
                              "N/A"
                            ) : column.format === "date" ? (
                              getDateTime(value)
                            ) : column.label === "Comments" ? (
                              <ReactReadMoreReadLess
                                charLimit={10}
                                readMoreText={"More ▼"}
                                readLessText={"Less ▲"}
                                readMoreStyle={{
                                  color: "#2835d5",
                                  cursor: "pointer",
                                }}
                                readLessStyle={{
                                  color: "#2835d5",
                                  cursor: "pointer",
                                }}
                              >
                                {!value ? "N/A" : value}
                              </ReactReadMoreReadLess>
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <TableCell
                colspan="10"
                style={{ "text-align": "center", margin: "10px 0px" }}
              >
                Data Not Available
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div>
        <TablePagination
          rowsPerPageOptions={[10, 50, 100, 1500]}
          component="div"
          count={totalRowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </Paper>
  );
}

export default InvAllTasklist;

{
  /* value==='2' ? 'Follow Up Mail Email' : value==='3' ? 'Follow Up Message' : value==='4' ? 'Call Back' ) */
}
